import Card from '../../components/card/card.vue';

export default {
  name: 'Contact',
  data() {
    return {};
  },
  components: {
    Card,
  },
};
